
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Getter } from 's-vuex-class'

import client from '@/api/client'

@Component<Tracker>({ components: {} })
export default class Tracker extends Vue {
    @Getter public getClickCardType!: string

    public mounted() {
        const formData = new FormData()
        formData.append(
            'event',
            'Upgrade to Additional Questions Screen is displayed'
        )
        formData.append('type', this.getClickCardType)
        client.post(`/ajax/conversation-spec/tracker`, formData, {
            baseURL: '/',
        })
    }
}
